/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import Vue from 'vue';

export default {
  state: {
    notifications: {},
    unreadCount: 0
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    notificationSave(state, payload) {
      if (state.notifications.items && state.notifications.items.length > 0) {
        state.notifications.items.find((item) => {
          if (item.id === payload.id) {
            Vue.set(item, 'saved', true);
            return true;
          }
        });
      }
    },
    notificationUnsave(state, payload) {
      if (state.notifications.items && state.notifications.items.length > 0) {
        state.notifications.items.find((item) => {
          if (item.id === payload.id) {
            Vue.set(item, 'saved', false);
            return true;
          }
        });
      }
    },
    notificationDisable(state, payload) {
      if (state.notifications.items && state.notifications.items.length > 0) {
        state.notifications.items.find((item) => {
          if (item.id === payload.id) {
            Vue.set(item, 'saved', true);
            return true;
          }
        });
      }
    },
    notificationRead(state, payload) {
      if (state.notifications.items && state.notifications.items.length > 0) {
        state.notifications.items.find((item) => {
          if (item.id === payload.id) {
            if (item.read === false) {
              if (this.unreadCount > 0) {
                this.unreadCount -= 1;
              } else {
                this.unreadCount = 0;
              }
            }
            Vue.set(item, 'read', true);
            return true;
          }
        });
      }
    },
    notificationsCountUnread(state, payload) {
      state.unreadCount = payload;
    }
  },
  actions: {
    setNotifications(state, payload) {
      state.commit('setNotifications', payload);
    },
    notificationSave(state, payload) {
      state.commit('notificationSave', payload);
    },
    notificationUnsave(state, payload) {
      state.commit('notificationUnsave', payload);
    },
    notificationDisable(state, payload) {
      state.commit('notificationDisable', payload);
    },
    notificationRead(state, payload) {
      state.commit('notificationRead', payload);
    },
    notificationsCountUnread(state, payload) {
      state.commit('notificationsCountUnread', payload);
    },
    notificationDelete(state, payload) {
      state.commit('notificationDelete', payload);
    }
  },
  getters: {
    getNotifications(state) {
      return state.notifications;
    },
    getCountUnreadNotifications(state) {
      return state.unreadCount;
    }
  }
};
